import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { dateUtils } from 'uitk-react-calendar';
import styles from '../uitk-date-selector.css';

var getClassNameList = classNames.bind(styles);
var dateDisplayClassName = 'uitk-date-display';
var UitkDateDisplay = function (props) {
    var id = props.id, _a = props.locale, locale = _a === void 0 ? 'en-US' : _a, _b = props.label, label = _b === void 0 ? 'Date' : _b, date = props.date, _c = props.isActive, isActive = _c === void 0 ? false : _c, _d = props.dateFormatOptions, dateFormatOptions = _d === void 0 ? {
        month: 'short',
        day: 'numeric',
        weekday: 'short'
    } : _d, onDateDisplayClick = props.onDateDisplayClick;
    var value = date ? dateUtils.getLocaleDateString(date, locale, dateFormatOptions) : label;
    var selectionButtonClasses = getClassNameList(dateDisplayClassName, {
        'selection-filled': date,
        selected: isActive
    });
    return (React.createElement("button", { type: "button", "aria-pressed": isActive, id: id, className: selectionButtonClasses, onClick: onDateDisplayClick },
        React.createElement("span", { className: "".concat(dateDisplayClassName, "-value") }, value)));
};

export { UitkDateDisplay };
